import axios from "axios";

import { isDev } from "_src/utils";

// 通用接口
// 推送交易到合约
export function getPolygonGasPrice(params) {
  const testUrl = "https://gasstation-mumbai.matic.today/v2";
  const productUrl = "https://gasstation-mainnet.matic.network/v2";

  return axios.get(isDev() ? testUrl : productUrl, { params }).then((res) => {
    return res;
  });
}
